import type {Button} from '@superweb/ui'
import React, {Suspense, useState} from 'react'

import {useConfig} from '../../../../../../config'
import {Resource} from '../../../../../../utils'
import {useDownloadErrorHandler} from '../../hooks'
import styleClasses from './classes.module.css'
import {DownloadButton} from './DownloadButton'

type Props = {tariff: string; country: string} & React.ComponentProps<typeof Button>

export function NddDownloadButtonContainer({tariff, country, ...buttonProps}: Props) {
  const [csvResource, setCsvResource] = useState<Resource<boolean>>()
  const errorHandler = useDownloadErrorHandler()
  const {tariffsService} = useConfig()

  const onButtonClick = () =>
    void setCsvResource(new Resource(() => tariffsService.fetchNddExcel(country, tariff).catch(errorHandler)))

  return (
    <Suspense
      fallback={
        <div className={styleClasses.nddDownloadButtonWrapper}>
          <DownloadButton {...buttonProps} progress />{' '}
        </div>
      }
    >
      <div className={styleClasses.nddDownloadButtonWrapper}>
        <DownloadButton {...buttonProps} fileResource={csvResource} onPress={onButtonClick} />
      </div>
    </Suspense>
  )
}
